// Buttons with ICONS SVG background
//---------------------------------------

$(".button.add-icon-on-right.arrow-right").each(function() {
    //$(this).addClass('external');
    $(this).append('<svg class="icon" viewBox="0 0 25 15"><use xlink:href="#arrow-right"></use></svg>');
});
$(".button.add-icon-on-left.arrow-left").each(function() {
    //$(this).addClass('external');
    $(this).append('<svg class="icon" viewBox="0 0 25 15"><use xlink:href="#arrow-left"></use></svg>');
});
$(".button.add-icon-on-right.chevron-right").each(function() {
    //$(this).addClass('external');
    $(this).append('<svg class="icon" viewBox="0 0 16 16"><use xlink:href="#chevron-right"></use></svg>');
});
$(".button.add-icon-on-left.chevron-right").each(function() {
    //$(this).addClass('external');
    $(this).append('<svg class="icon" viewBox="0 0 16 16"><use xlink:href="#chevron-left"></use></svg>');
});

$(".button.add-icon-on-left.checked").each(function() {
    //$(this).addClass('external');
    $(this).append('<svg class="icon" viewBox="0 0 40 30"><use xlink:href="#checked"></use></svg>');
});
$(".button.add-icon-on-left.download").each(function() {
    //$(this).addClass('external');
    $(this).append('<svg class="icon" viewBox="0 0 40 40"><use xlink:href="#download"></use></svg>');
    $(this).attr( "download", "download" );
});


// 8. SHORTCODES
// ----------------

// column.block wrapper - [block] shortcode
jQuery(".column.block").wrapAll("<div class='row block-wrapper' />");